export default __webpack_public_path__ + "static/media/home-yoga-meditation-facility-img01.48e9f7fa.jpg";